import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { MasterPresenter } from '@/app/ui/presenters/MasterPresenter'
import { Master } from '@/domain/entities/Master'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface MasterState {
  MasterData: Master
  PositionData: Master
  DealerNameData: Master
  TrainingMaterialData: Master
  GuideMaterialData: Master
  InfoMaterialData: Master
  BulletinMaterialData: Master
  DealerBranchData: Master
  SalesmanLevelData: Master
  SalesmanData: Master
  DealerGroupData: Master
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'master' })
class Masters extends VuexModule implements MasterState {
  public isLoading = true
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'title', sortable: true },
    { key: 'attachment', sortable: false },
    { key: 'deletable', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public MasterData = new Master(true, '', [])
  public PositionData = new Master(true, '', [])
  public DealerNameData = new Master(true, '', [])
  public TrainingMaterialData = new Master(true, '', [])
  public GuideMaterialData = new Master(true, '', [])
  public InfoMaterialData = new Master(true, '', [])
  public BulletinMaterialData = new Master(true, '', [])
  public DealerBranchData = new Master(true, '', [])
  public SalesmanLevelData = new Master(true, '', [])
  public SalesmanData = new Master(true, '', [])
  public DealerGroupData = new Master(true, '', [])
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }
  public paginationParamSpesial = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
    spesial: '1',
  }

  @Action
  public async getCity() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'city')
      .then((res: Master) => {
        this.setMasterData(res)
        //  console.log('resssss2222', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getPosition() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'job-positions')
      .then((res: Master) => {
        this.setPositionData(res)
        //  console.log('salesman position', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getSalesman() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'salesmen')
      .then((res: Master) => {
        this.setSalesmanData(res)
        //  console.log('salesman ==>', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getDealerName() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'dealer')
      .then((res: Master) => {
        this.setDealerNameData(res)
        //  console.log('dealer name', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }
  @Action
  public async getTitleNotification() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'titlenotification')
      .then((res: Master) => {
        this.setMasterData(res)
        //  console.log('resssss2222', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getTrainingMaterial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'training')
      .then((res: Master) => {
        this.setTrainingMaterialData(res)
        //  console.log('training material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getTrainingMaterialSpesial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMasterspesial(this.paginationParamSpesial, 'training')
      .then((res: Master) => {
        this.setTrainingMaterialData(res)
        //  console.log('training material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getGuideMaterial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'sop')
      .then((res: Master) => {
        this.setGuideMaterialData(res)
        //  console.log('guide material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getGuideMaterialSpesial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMasterspesial(this.paginationParamSpesial, 'guide')
      .then((res: Master) => {
        this.setGuideMaterialData(res)
        //  console.log('guide material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getInfoMaterial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'info')
      .then((res: Master) => {
        this.setInfoMaterialData(res)
        //  console.log('info material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getInfoMaterialSpesial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMasterspesial(this.paginationParamSpesial, 'info')
      .then((res: Master) => {
        this.setInfoMaterialData(res)
        //  console.log('info material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getBulletinMaterial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'bulletin')
      .then((res: Master) => {
        this.setBulletinMaterialData(res)
        //  console.log('bulletin material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getBulletinMaterialSpesial() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMasterspesial(this.paginationParamSpesial, 'bulletin')
      .then((res: Master) => {
        this.setBulletinMaterialData(res)
        //  console.log('bulletin material', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getDealerBranch() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'branch')
      .then((res: Master) => {
        this.setDealerBranchData(res)
        //  console.log('dealer branch', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public async getDealerGroup() {
    this.setLoading(true)
    const presenter = await container.resolve(MasterPresenter)
    presenter
      .loadMaster(this.paginationParam, 'group')
      .then((res: Master) => {
        this.setGroupData(res)
        //  console.log('dealer group', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Mutation
  private setMasterData(master: Master) {
    this.MasterData = master
  }

  @Mutation
  private setPositionData(master: Master) {
    this.PositionData = master
  }

  @Mutation
  private setSalesmanData(master: Master) {
    this.SalesmanData = master
  }

  @Mutation
  private setDealerNameData(master: Master) {
    this.DealerNameData = master
  }

  @Mutation
  private setTrainingMaterialData(master: Master) {
    this.TrainingMaterialData = master
  }

  @Mutation
  private setGuideMaterialData(master: Master) {
    this.GuideMaterialData = master
  }

  @Mutation
  private setInfoMaterialData(master: Master) {
    this.InfoMaterialData = master
  }

  @Mutation
  private setBulletinMaterialData(master: Master) {
    this.BulletinMaterialData = master
  }

  @Mutation
  private setDealerBranchData(master: Master) {
    this.DealerBranchData = master
  }

  @Mutation
  private setGroupData(master: Master) {
    this.DealerGroupData = master
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
}

export const MasterModule = getModule(Masters)
